import React, { useEffect, useState } from "react";
import TimePicker from "react-time-picker";
import { Row, Col } from "react-bootstrap";

function TimeRangePicker(props) {
  const {
    setStartTime,
    setEndTime,
    startTime,
    endTime,
    startTimeLabel = `Start Time`,
    endTimeLabel = `End Time`,
    readOnly = false,
    minTime,
  } = props;

  const [initialTime, setInitialTime] = useState(startTime ?? "08:00");
  const [finalTime, setFinalTime] = useState(endTime ?? "09:00");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (startTime && setInitialTime) {
      setInitialTime(startTime);
    }
  }, [startTime]);

  useEffect(() => {
    if (endTime && setEndTime) {
      setFinalTime(endTime);
    }
  }, [endTime]);

  useEffect(() => {
    if (setStartTime && !startTime) {
      setStartTime("08:00");
    }

    if (setEndTime && !endTime) {
      setEndTime("09:00");
    }
  }, [0]);

  const handleChange = (name, value) => {
    if (name === "startTime") {
      setInitialTime(value);
    } else if (name === "endTime") {
      setFinalTime(value);
    }

    const finalTimeFlag = setEndTime && name === "endTime";
    if (setEndTime) {
      if (
        (finalTimeFlag && value <= initialTime) ||
        (!finalTimeFlag && finalTime <= value)
      ) {
        setError(true);
        setErrorMessage("End time must be after start time");
      } else {
        setError(false);
      }
    }

    if (!finalTimeFlag && minTime && value < minTime) {
      setError(true);
      setErrorMessage(`Time must be at least ${minTime}`);
    }

    if (name === "startTime") {
      setStartTime(value);
    } else if (name === "endTime") {
      setEndTime(value);
    }
  };

  return (
    <div>
      <Row>
        <Col>
          <Row>
            <label>{startTimeLabel}</label>
          </Row>
          <Row>
            <TimePicker
              value={initialTime}
              onChange={(value) => {
                handleChange("startTime", value);
              }}
              format="h:mm a"
              //hourAriaLabel={initialTime ? (parseInt(initialTime.split(":")[0]) >= 12 ? "PM" : "AM") : "AM"}
              showLeadingZeros={true}
              clockIcon={null}
              clearIcon={null}
              disableClock={true}
              step={15}
              disabled={readOnly}
            />
          </Row>
        </Col>
        {setEndTime && (
          <>
            <Col>
              <Row>
                <label>{endTimeLabel}</label>
              </Row>
              <Row>
                <TimePicker
                  value={finalTime}
                  onChange={(value) => handleChange("endTime", value)}
                  format="h:mm a"
                  //amPmAriaLabel={(hour) => (hour >= 12 ? "PM" : "AM")}
                  //hourAriaLabel={(hour) => (hour >= 12 ? "PM" : "AM")}
                  showLeadingZeros={false}
                  clockIcon={null}
                  clearIcon={null}
                  disableClock={true}
                  step={15}
                  disabled={readOnly}
                />
              </Row>
            </Col>
          </>
        )}
      </Row>
      <Row>{error && <small>{errorMessage}</small>}</Row>
    </div>
  );
}

export default TimeRangePicker;
